import { Box, Button, Divider, Icon, Typography } from "@mui/material";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { DialogContext } from "../../../contexts/DialogueContext";
import { RootState } from "../../../slices/Store";
import ProjectFolderItem from "../../projects/components/ProjectFolderItem";
import SelectFolderDialog from "../SelectFolderDialog";

// updated
export default function ProjectDetailFolders() {
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );

    const { openDialog } = useContext(DialogContext);

    const selectFolder = () => {
        openDialog(<SelectFolderDialog />);
    };

    if (projectDetailState.projectDetail.folders.length === 0) {
        return (
            <Button
                fullWidth
                onClick={selectFolder}
                variant="outlined"
                sx={{ mb: 2 }}
                startIcon={<Icon>add</Icon>}
            >
                انتخاب پوشه
            </Button>
        );
    }

    return (
        <Box sx={{ mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "end" }}>
                <Typography sx={{ flexGrow: 1 }}>پوشه ها</Typography>

                <Button
                    onClick={selectFolder}
                    size="small"
                    variant="outlined"
                    startIcon={<Icon>add</Icon>}
                >
                    انتخاب از لیست پوشه ها
                </Button>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                {projectDetailState.projectDetail.folders.map((f) => (
                    <ProjectFolderItem key={f.id} folder={f} />
                ))}
            </Box>
        </Box>
    );
}
